import { Route, Routes } from "react-router-dom";
import { lazy } from "react";
import { ApplicantLayout } from "../components/layouts/ApplicantLayout";
const ApplicantHome = lazy(() => import("./authenticated/applicant/home"));
const ApplicantProcessingHome = lazy(() => import("@/features/applicant/home/processing-home"));
const DashboardRoute = lazy(() => import("./authenticated/admin/Dashboard"));
const PaymentsRoute = lazy(() => import("./public/Payments").then((m) => ({ default: m.PaymentsRoute })));
const ApplicationInfo = lazy(() => import("../features/applicant"));
const PersonalInfoRoute = lazy(() => import("./authenticated/applicant/PersonalInfo"));
const AddressesRoute = lazy(() => import("./authenticated/applicant/Addresses"));
const EmailsRoute = lazy(() => import("./authenticated/applicant/Emails"));
const TelephonesRoute = lazy(() => import("./authenticated/applicant/Telephones"));
const YourselfRoute = lazy(() => import("./authenticated/applicant/Yourself"));
const BiographicalRoute = lazy(() => import("./authenticated/applicant/Biographical"));
const GuardiansRoute = lazy(() => import("./authenticated/applicant/Guardians"));
const SchoolingRoute = lazy(() => import("./authenticated/applicant/Schooling"));
const StudyHistoryRoute = lazy(() => import("./authenticated/applicant/StudyHistory"));
const DocumentsRoute = lazy(() => import("./authenticated/applicant/Documents"));
const ExamDetailsRoute = lazy(() => import("./authenticated/applicant/Exams"));
const NOKRoute = lazy(() => import("./authenticated/applicant/NOK"));
const QualificationsRoute = lazy(() => import("./authenticated/applicant/Qualifications"));
const SummaryRoute = lazy(() => import("./authenticated/applicant/Summary"));
const PrintRoute = lazy(() => import("./authenticated/applicant/Print"));
const ChangeOfMind = lazy(() => import("../features/applicant/change-of-mind"));
const POPIA = lazy(() => import("../features/applicant/popia"));
const ImportantNotices = lazy(() => import("../features/applicant/important-notices"));
const NotFoundAuthed = lazy(() => import("./authenticated/admin/NotFound"));
const ReportError = lazy(() => import("@/features/report-error"));
import { useAuthStore } from "@/stores/use-auth-store";
const CheckMyApplicationRoute = lazy(() => import("./authenticated/applicant/CheckMyApplication"));
import { ApplicantProcessingLayout } from "@/components/layouts/ApplicantProcessingLayout";
const Documents = lazy(() => import("@/features/applicant/documents"));
const UpdateMyDetails = lazy(() => import("@/features/applicant/update-my-details"));

export const ApplicantRoutes = () => {
  const { user } = useAuthStore();
  console.log(user);

  if (user?.appStatus === "A" || user?.appOnHold === "N") {
    return (
      <Routes>
        <Route element={<ApplicantProcessingLayout />}>
          <Route index element={<ApplicantProcessingHome />} />
          <Route path="dashboard" element={<DashboardRoute />} />
          <Route path="application" element={<CheckMyApplicationRoute />} />
          <Route path="application/documents" element={<Documents />} />
          <Route path="payments" element={<PaymentsRoute />} />
          <Route path="com" element={<ChangeOfMind />} />
          <Route path="update-my-details" element={<UpdateMyDetails />} />
          <Route path="popia" element={<POPIA />} />
          <Route path="important-notices" element={<ImportantNotices />} />
          <Route path="report-error" element={<ReportError />} />
          <Route path="*" element={<NotFoundAuthed />} />
        </Route>
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<ApplicantLayout />}>
        <Route index element={<ApplicantHome />} />
        <Route path="dashboard" element={<DashboardRoute />} />
        <Route path="payments" element={<PaymentsRoute />} />
        <Route path="application" element={<ApplicationInfo />}>
          <Route index element={<PersonalInfoRoute />} />
          <Route path="addresses" element={<AddressesRoute />} />
          <Route path="emails" element={<EmailsRoute />} />
          <Route path="telephones" element={<TelephonesRoute />} />
          <Route path="yourself" element={<YourselfRoute />} />
          <Route path="biographical" element={<BiographicalRoute />} />
          <Route path="guardians" element={<GuardiansRoute />} />
          <Route path="schooling" element={<SchoolingRoute />} />
          <Route path="study-history" element={<StudyHistoryRoute />} />
          <Route path="documents" element={<DocumentsRoute />} />
          <Route path="exams" element={<ExamDetailsRoute />} />
          <Route path="nok" element={<NOKRoute />} />
          <Route path="qualifications" element={<QualificationsRoute />} />
          <Route path="summary" element={<SummaryRoute />} />
          <Route path="print" element={<PrintRoute />} />
        </Route>

        <Route path="com" element={<ChangeOfMind />} />

        <Route path="popia" element={<POPIA />} />

        <Route path="important-notices" element={<ImportantNotices />} />
        <Route path="report-error" element={<ReportError />} />
        <Route path="*" element={<NotFoundAuthed />} />
      </Route>
    </Routes>
  );
};
